import styled from '../../../styles/theme';
import { GeoLocationInputStyled } from '../GeoLocationInputStyled';

export const GeoLocationInputStyledAC = styled(GeoLocationInputStyled)`
    .geolocation-input--container {
        .geolocation-input--textfield-container {
            input {
                font-size: ${({ theme }) => theme.fontSizes.h6};
            }
        }
    }
`;
